module.exports = __webpack_public_path__ + "img/edit.048bc686.png";